module.exports = __webpack_public_path__ + "static/img/08ctrlC.722826dd.png";